import script from "./BuscadorParaTi.vue?vue&type=script&setup=true&lang=js"
export * from "./BuscadorParaTi.vue?vue&type=script&setup=true&lang=js"

import "./BuscadorParaTi.vue?vue&type=style&index=0&id=d35dc686&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d35dc686"]])

export default __exports__